<template>
    <div class="quiz quiz__introduction" :style="`background-image: url(${ asset_path });`">
        <div class="quiz__intro-copy">
            <h1 class="quiz__intro-title">Find Your Perfect Gift</h1>
            <p class="quiz__intro-message">Use our Holiday Gift Finder to simplify your holiday shopping.</p>

            <button @click="startQuiz" class="quiz__intro-start-btn">Start Now</button>
        </div>
    </div>
</template>

<script>
import { contentAssetPath } from '../utilities'

export default {
    data() {
        return {
            asset_path: contentAssetPath('img/introduction_page_background.jpg'),
        }
    },
    methods: {
        startQuiz() {
            this.$emit('next', { path: '/giftguide/' })
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/js/app/components/introduction.vue